import React, { useEffect } from "react";
import { Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useNavigate } from "react-router-dom";


import { OfficePage } from "../../components/OfficePage";
import { MemberContextProvider } from "../../hooks/MemberContext";
import { RecentActivityContent } from "./RecentActivity/RecentActivityContent";
import { RankQualificationsContent } from "./RankQualifications/RankQualificationsContent";
import { CenturionQualificationsContent } from "./CenturionQualifications/CenturionQualificationsContent";
import { BackToOldOfficeContent } from "./BackToOldOffice/BackToOldOfficeContent";
import { StatsContent } from "./Stats/StatsContent";
import { ExplainedButton } from "../../components/ExplainedButton";
import { NewsContent } from "./News/NewsContent";
import { GlobalNoticeComponent } from "../../components/GlobalNoticeComponent";

const DashboardScreen = () => {
  const theme = useTheme();
  const viewportIsLarge = useMediaQuery(theme.breakpoints.up("lg"));
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to /dashboard if accessed via root URL "/"
    const currentPath = window.location.pathname;
    if (currentPath !== "/dashboard") {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);

  return (
    <OfficePage pageTitle="dashboard">
      <MemberContextProvider>
        <Stack
          direction={viewportIsLarge ? "row" : "column"}
          gap={viewportIsLarge ? "18px" : "20px"}
          alignItems={viewportIsLarge ? "flex-start" : "stretch"}>
          <Stack sx={{ flex: "1 1 100%" }} gap="20px">
            {/* show global notice component at this level if not large viewport */}
            {!viewportIsLarge && <GlobalNoticeComponent />}
            <BackToOldOfficeContent />
            <RankQualificationsContent />
            {
              viewportIsLarge &&
              <StatsContent />
            }
          </Stack>
          <Stack sx={{ flex: "1 1 100%" }}>
            <CenturionQualificationsContent />
          </Stack>
          {
            !viewportIsLarge &&
            <Stack sx={{ flex: "1 1 100%" }}>
              <StatsContent />
            </Stack>
          }
          <Stack gap="20px" sx={{ flex: "1 1 100%" }}>
            <NewsContent />
            <RecentActivityContent />
          </Stack>
        </Stack>
        <Stack alignItems="center" mt={viewportIsLarge ? 10 : 4} mb={viewportIsLarge ? 10 : 4}>
          <ExplainedButton
            type="dashboard"
            testId="dashboard-explained-button"
            imgUrl="icons/centurion-info.svg"
            buttonText="dashboard_explained"
            urlKey="dashboard_explained_url"
          />
        </Stack>
      </MemberContextProvider>
    </OfficePage>
  );
};

export { DashboardScreen };
